/*
 *   File : faq.js
 *   Author : https://evoqins.com
 *   Description : FAQ page
 *   Integrations : 
 *   Version : 1.0.0
*/

import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

// Components
import { TextButton } from "../../Component/Buttons";
import { Icon } from "../../Component/Icon";
import { _scrollToTop } from "../../Helper";
import { Loader } from "../../Component/Others";
import { APIService } from "../../Service";

// Styles 
import Colors from "../../Styles/color.scss";

function Faq(props) {

    const navigate = useNavigate();
    const [FAQ, setFAQ] = useState({});
    const [dataLoading, setDataLoading] = useState(true);

    useEffect(() => {
        // Scroll the page to top
        _scrollToTop();

        // API data
        _getFAQDATA();
    }, []);

    const _handleBack = () => {
        navigate(-1);
        // props.handlePublicRouter();
    };


    // API call
    const _getFAQDATA = async () => {

        let url = "organization/static-details";
        let data = {
            "type": "FAQ"
        };
        let is_post = true;
        let token = "my-auth-token";

        const response = await APIService(url, data, is_post, token);
        if (response.status_code === 200) {
            setFAQ(response.data.htmlContent);
        } else {
            setFAQ("");
        }
        setDataLoading(false);
    };

    return (
        <div>

            {
                dataLoading ?
                    <Loader wrapperClassName="min-vh-100 margin-200px-top" />
                    :
                    <>

                        <TextButton name="FAQ"
                            labelClass="e-font-16-res"
                            icon={true}
                            type={2}
                            onPress={_handleBack} />
                        <div className="row">

                            <div className={props.type == 2 ? "col-12" : "col-12 col-lg-10 col-xl-7"}>
                                <div className="pt-3 pb-0 card-box-shadow e-bg-white my-4 border-radius-8 px-0">

                                    <div className="row px-3">
                                        <div dangerouslySetInnerHTML={{ __html: FAQ }}></div>
                                    </div>

                                    <div className="row m-0 p-0">
                                        {/* Support team info */}
                                        <div className="py-3 e-bg-magnolia " id="gradient-border-support-info">

                                            <h6 className="mb-0 e-text-chinese-black e-primary-font-clash-display e-font-weight-500 e-font-16 line-height-24px">
                                                Don't hesitate to get in touch!
                                            </h6>
                                            <p className="mb-0 e-text-outer-space e-alt-font-lato e-font-weight-400 e-font-12 line-height-18px">
                                                Our support team is here to help!
                                            </p>
                                            <div className='d-flex flex-wrap align-items-center gap-3 gap-sm-5 margin-20px-top'>
                                                <div className='d-flex gap-2 align-items-center'>
                                                    <span className="d-flex align-items-center justify-content-center e-secondary-bg-gradient w-18px h-18 border-radius-80 line-height-0px">
                                                        <Icon icon={"e-mail"}
                                                            color={Colors.magnolia}
                                                            size="10px" />
                                                    </span>
                                                    <a href='mailto:hello@Indvestment.in' className='text-decoration-none text-decoration-hover-underline text-reset'>
                                                        <span className="e-text-outer-space e-alt-font-lato e-font-weight-400 e-font-14 line-height-20px">
                                                            hello@indvestment.com
                                                        </span>
                                                    </a>
                                                </div>
                                                <div className='d-flex gap-2 align-items-center'>
                                                    <span className="d-flex align-items-center justify-content-center e-secondary-bg-gradient w-18px h-18 border-radius-80 line-height-0px">
                                                        <Icon icon={"phone-icon"}
                                                            color={Colors.magnolia}
                                                            size="10px" />
                                                    </span>
                                                    <a href='tel:+919876543210' className='text-decoration-none text-decoration-hover-underline text-reset'>
                                                        <span className="e-text-outer-space e-alt-font-lato e-font-weight-400 e-font-14 line-height-20px">
                                                            +91 98765 43210
                                                        </span>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>
                    </>
            }
        </div>
    )
}

export default Faq